<template>
  <nav>
    <v-app-bar
      app
      flat
      hide-on-scroll
      scroll-threshold="50"
    >
      <v-app-bar-nav-icon
        depressed
        @click="drawer = !drawer"
      >
        <v-icon color="primary">
          mdi-menu
        </v-icon>
      </v-app-bar-nav-icon>
      <v-app-bar-title class="grey--text">
        哈哈
      </v-app-bar-title>
      <v-app-bar-title class="accent--text mr-2">
        我的
      </v-app-bar-title>

      <!-- 使用 <portal to="app-header"> 显示到这里 -->
      <portal-target
        name="app-header"
        class="flex-grow-1"
      />

      <v-app-bar-nav-icon
        depressed
        @click="toggleDarkMode"
      >
        <v-icon
          v-if="$vuetify.theme.dark"
          color="accent"
        >
          mdi-white-balance-sunny
        </v-icon>
        <v-icon
          v-else
          color="accent"
        >
          mdi-weather-night
        </v-icon>
      </v-app-bar-nav-icon>
      <!-- <v-app-bar-nav-icon
        depressed
        href="https://github.com/miloweimo"
      >
        <v-icon color="accent">
          mdi-github
        </v-icon>
      </v-app-bar-nav-icon> -->
      <v-app-bar-nav-icon
        depressed
        @click="$router.push('/')"
      >
        <v-icon color="accent">
          mdi-home
        </v-icon>
      </v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      dense
      :class="isDark ? 'grey darken-4' : 'primary'"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6 d-flex align-center">
            <span class="grey--text">哈哈</span>
            <span class="accent--text">我的</span>
            <v-icon color="accent">
              mdi-spin mdi-star
            </v-icon> 
            <v-spacer />
            <v-btn
              dense
              icon
              @click="drawer = !drawer"
            >
              <v-icon color="accent">
                mdi-menu
              </v-icon>
            </v-btn>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-divider></v-divider> -->

      <v-list
        dense
        nav
      >
        <v-list-item-group
          :value="selected"
          active-class="accent--text"
        >
          <v-list-item
            v-for="item in items"
            :key="item.title"
            link
            @click="handle(item)"
          >
            <v-list-item-icon>
              <v-icon
                :color="isDark ? 'grey' : ''"
              >
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title :class="isDark ? 'grey--text' : ''">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { navModules } from "@/modules";

export default {
  name: "Navbar",
  data() {
    return {
      drawer: false, // 是否打开
      items: [
        { title: "Home", icon: "mdi-home-variant-outline", linkto: "/" },
      ],
      selected: null,
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
    routeName() {
      return this.$route.name;
    },
    // selected() {
    //   return this.items.find((item) => item.linkto === this.$route.path);
    // },
  },
  created() {
    this.items = navModules;
    this.toggleDarkMode(true);
  },
  methods: {
    handle(item) {
      const { linkto: path, href } = item;
      if (href) {
        // window.open(href);
        // 页内跳转
        window.location.href = href;
        return;
      }
      console.log(path, this.$router.currentRoute.fullPath);
      if (path === this.$router.currentRoute.fullPath) return;
      this.$router.push({ path: path });
    },
    toggleDarkMode(isFrist) {
      const theme = document.cookie.split("; ")?.find((item) => item.startsWith("theme="))?.split("=")?.[1];
      // console.log('isFrist:', isFrist === true, 'cookie theme:', theme, 'System dark pref:', window.matchMedia("(prefers-color-scheme: dark)").matches);
      if (isFrist === true) {
        // 首次检查系统颜色模式
        if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
          this.$vuetify.theme.dark = true;
          document.cookie = "theme=dark; path=/";
        }
        if (theme === "dark") {
          this.$vuetify.theme.dark = true;
        }
        if (theme === "light") {
          this.$vuetify.theme.dark = false;
        }
      } else {
        // 切换
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      } 
      // 添加 <meta name="color-scheme" content="dark light">
      if (this.$vuetify.theme.dark) {
        document.querySelector("meta[name='color-scheme']").content = "dark";
        // prefers-color-scheme 兼容
        document.querySelector("html").setAttribute("data-prefers-color-scheme", "dark");
        // 设置本次会话有效的cookie
        document.cookie = "theme=dark; path=/";
      } else {
        document.querySelector("meta[name='color-scheme']").content = "light";
        // prefers-color-scheme 兼容
        document.querySelector("html").setAttribute("data-prefers-color-scheme", "light");
        document.cookie = "theme=light; path=/";
      }
    },
  }
};
</script>

<style></style>
